import { Container } from "@components/ui/Container";
import { Button } from "@components/ui/Button";
import { company } from "@data/company";
import styles from "./Cta.module.css";

type CtaProps = {
  title?: string;
  body?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
};

export function Cta({
  title = "¿Necesitás una cotización?",
  body = "Hablá con un productor en menos de 24 horas. Te respondemos por WhatsApp, mail o teléfono.",
  primaryLabel = "Cotizar por WhatsApp",
  secondaryLabel = "Llamar ahora",
}: CtaProps) {
  return (
    <section style={{ paddingBlock: "clamp(var(--space-12), 6vw, var(--space-20))" }}>
      <Container>
        <div className={styles.wrap}>
          <div>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.body}>{body}</p>
          </div>
          <div className={styles.actions}>
            <Button
              as="a"
              href={`https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
                "Hola, quiero una cotización",
              )}`}
              target="_blank"
              rel="noopener"
              variant="cta"
              size="lg"
            >
              {primaryLabel}
            </Button>
            <Button
              as="a"
              href={`tel:${company.phone.replace(/\s/g, "")}`}
              variant="ghost"
              size="lg"
              className={styles.secondaryAction}
            >
              {secondaryLabel}
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
